import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Eryk/subs.vtt';
import poster from '@/static/assets/reviews/Eryk/video.jpg';

export const Eryk: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Car],
  reviewerName: 'Eryk',
  videoUrl: `${ASSETS_URL}/car/Eryk.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
